<template>
  <Teleport to="body">
    <template v-if="modalRequested">
      <div class="modal inmodal" :id="id">
        <div class="modal-dialog" :class="modalClass">
          <div class="modal-content animated">
            <div class="modal-header">
              <slot name="header">
                <button type="button" class="close" data-dismiss="modal" @click="$modal.hide(id)">&times;</button>
                <i v-if="icon" :class="'fa modal-icon ' + icon"></i>
                <h4 class="modal-title">{{ title }}</h4>
              </slot>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
            <div class="modal-footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else />
  </Teleport>
</template>
<!--
The "<template v-else />" here prevents rendering empty
HTML comment block when modal is not present in DOM.
-->

<script>
import { mapActions } from 'pinia'
import { useModalStore } from "../stores/modal"

export default {
  emits: ['shown', 'hidden'],

  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    modalClass: {
      type: String,
      default: 'modal-lg'
    },
    icon: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      modalRequested: false,
    }
  },

  methods: {
    ...mapActions(useModalStore, ['registerModal']),

    show() {
      this.modalRequested = true;
      this.$nextTick(() => {
        this.attachModalEvents();
        $('#' + this.id).modal('show');
      });
    },

    hide() {
      $('#' + this.id).modal('hide');
      this.modalRequested = false;
    },

    toggle() {
      if (this.modalRequested) {
        this.hide();
      } else {
        this.show();
      }
    },

    attachModalEvents() {
      /**
       * Please note that jQuery is utilized here because it's built into Bootstrap 4.
       * In Bootstrap 5, the native "addEventListener" is available for this purpose.
       */
      let $modalElement = $('#' + this.id);

      $modalElement.on('show.bs.modal', event => {
        this.$emit('shown', event);
      });

      $modalElement.on('hidden.bs.modal', event => {
        this.$emit('hidden', event);

        // Remove modal from DOM.
        this.modalRequested = false;
      });
    },

    setup() {
      // Find the trigger.
      const $trigger = document.querySelector('*[data-target="#' + this.id + '"]');
      if (!$trigger) return;

      // Attach capturing event listener, that inserts all modal code in DOM by switching
      // modalRequested to true.
      $trigger.addEventListener('click', () => {
        // Add modal to DOM.
        this.modalRequested = true;
        // Attach modal events.
        this.$nextTick(() => {
          this.attachModalEvents();
        });
      }, true);
    },

  },

  mounted() {
    this.registerModal(this.id, this);
    this.setup();
  },

}
</script>
